import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-scheduler-router',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './scheduler-router.component.html',
  styleUrl: './scheduler-router.component.scss'
})
export class SchedulerRouterComponent {

}
